import React from "react";
import styled, { css } from "styled-components";
import MapContext from "../MapContext";
import Loading from "../Loading";
import Contributor from "../common/Contributor";

class Contributors extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contributors: [],
            loading: false
        }
    }

    componentDidMount() {
        this.setState({ loading: true });

        import("../../data/top_contributors.json")
            .then(data => {
                this.setState({
                    contributors: data.default,
                    loading: false
                })
            })
    }

    render() {
        return <MapContext.Consumer>
            { ({ mode }) => {
                return <Container>
                    <Title>Worldwide top contributors</Title>
                    <Loading isDisplayed={ this.state.loading } />
                    <LanguagesWrapper>
                        {this.state.contributors.map((profile, index) => {
                            return <Contributor 
                                mode={ mode }
                                key={ index }
                                displayFlag={ true }
                                profile={ profile } />
                        })}
                    </LanguagesWrapper>
                </Container>
            }}
        </MapContext.Consumer>
    }
}

const Container = styled.div`
    width: 100%;
    padding: 8px 9px;
`

const Title = styled.h2`
    font-size: 18px;
    text-align: center;
    margin: 12px 0;
`

const LanguagesWrapper = styled.div`
    font-size: 14px;
    overflow: auto;
    padding: 0 12px 0 0;
    height: calc(100vh - 90px);

    &::-webkit-scrollbar-thumb {
        background: #565656;
        border-radius: 10px;
    }

    &::-webkit-scrollbar {
        background: #40404075;
        width: 8px;
        border-radius: 10px;
    }
`

const LangWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    margin-bottom: 12px;
    position: relative;
    font-weight: bold;
    background: #e2e2e2;
    padding: 12px;
    border-radius: 5px;

    ${ props => props.mode === "dark" && css`
        background: #353535;
    ` }

    p {
        z-index: 100;
    }
`

export default Contributors;